import styled from "styled-components";
import { Typography } from "antd";

export const TableHeader = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0px;
  width: 100%;
  .mr-a-1 {
    margin-right: -6px !important;
  }
  @media (max-width: 767px) {
    font-size: 14px;
    .border-right {
      border: 0;
      padding: 0;
      margin: 0;
    }
  }
  .ant-typography {
    color: ${({ theme }) => theme.text};
    &.ant-typography-secondary {
      color: ${({ theme }) => theme.textOverlay2};
    }
  }
`;

export const WrapSpin = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${({ theme }) => theme.bg11};
  opacity: 0.8;
`;
export const PaginationWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: right;
  color: ${({ theme }) => theme.text};
  gap: 0px;
  margin-right: -6px !important;
  @media (max-width: 767px) {
    font-size: 14px;
    .border-right {
      border: 0;
      padding: 0;
      margin: 0;
    }
  }

  .ant-typography {
    color: ${({ theme }) => theme.text};
    &.ant-typography-secondary {
      color: ${({ theme }) => theme.textOverlay2};
    }
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-btn {
    border-radius: 5px;
  }

  .d-ms-down-none {
    @media (max-width: 767px) {
      display: none;
    }
  }
`;

export const ContentTable = styled.div`
  background: ${({ theme }) => theme.bg7};
  backdrop-filter: blur(20px);
  border-radius: 8px;
  box-shadow: 0px 4px 8px ${({ theme }) => theme.boxShadow1};
  padding: 24px;
  height: 100%;
  @media (max-width: 991px) {
    padding: 15px;
    border-radius: 0px;
  }
  &.not-bg-content-table {
    background-color: transparent;
    padding: 0px;
    border-radius: 0px;
    box-shadow: 0px 0px 0px;
    @media (max-width: 767px) {
      padding: 0px;
    }
  }
  .style-table-bordered {
    .ant-table {
      border: 1px solid ${({ theme }) => theme.borderOverlay1} !important;
      padding-top: 1px;
      background: transparent;
      border-radius: 8px;
      overflow: hidden;
      table {
        color: ${({ theme }) => theme.text};
        .ant-table-tbody > tr {
          &:last-child {
            td {
              border-bottom: 0px !important;
            }
          }
          > td {
            border-bottom: 1px solid ${({ theme }) => theme.borderOverlay1};
            background: ${({ theme }) => theme.bg5};
            padding-left: 15px;
            padding-right: 15px;
          }
        }
        .ant-table-thead > tr > th {
          color: ${({ theme }) => theme.text};
          background: ${({ theme }) => theme.bg7};
          border-bottom: 0px;
          padding-left: 15px;
          padding-right: 15px;
          font-size: 13px;
        }
        .ant-table-tbody > tr.ant-table-row:hover > td {
          background: ${({ theme }) => theme.bg6}!important;
        }
        .ant-table-tbody > tr.ant-table-placeholder:hover > td {
          background: ${({ theme }) => theme.bg6}!important;
        }
      }
    }
  }
  .ant-empty-description {
    color: ${({ theme }) => theme.textOverlay};
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    background: transparent;
    color: ${({ theme }) => theme.text};
    border: none;
  }
  .ant-select-arrow {
    color: ${({ theme }) => theme.text};
  }
  .styled-spin {
    .ant-spin-dot-item {
      background-color: ${({ theme }) => theme.primary};
    }
  }
`;

export const TextSmall = styled(Typography.Text)`
  font-size: 12px;
`;
export const TextLink = styled.span`
  cursor: pointer;
  gap: 5px;
  align-items: center;
  &:hover {
    color: #40a9ff;
  }
  .anticon-clock-circle {
    font-size: 12px;
  }
`;
